import { Button } from '@shared/components/ui/button';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loader2 } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { WalletTransactionsAdvancedFilters } from '../../adapters/WalletApiAdapter';
import { useExportWalletTransactions } from '../../hooks/useExportWalletTransactions';

interface ExportTransactionsButtonProps {
  walletId?: number;
  advancedFilters?: WalletTransactionsAdvancedFilters;
  sorting?: { column: string; direction: 'asc' | 'desc' };
  disabled?: boolean;
}

export const ExportTransactionsButton: FC<ExportTransactionsButtonProps> = ({
  walletId,
  advancedFilters,
  sorting,
  disabled = false,
}) => {
  const { t } = useTranslation('walletsModule');
  const { exportWalletTransactions, isExporting } = useExportWalletTransactions(walletId);

  const handleExport = () => {
    exportWalletTransactions({
      ...(advancedFilters ? { advanced_filters: advancedFilters } : {}),
      ...(sorting ? { sorting } : {}),
    });
  };

  return (
    <Button
      onClick={handleExport}
      disabled={disabled || isExporting}
      type="button"
      size="sm"
      variant="outline"
      className={`!py-[9px] !px-2 text-icon bg-body-bg transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="export-excel-button"
      title={t('export.button', 'Exportar a Excel')}
    >
      {isExporting ? <Loader2 className="h-4 w-4 animate-spin" /> : <FontAwesomeIcon icon={faFileArrowDown} />}
    </Button>
  );
};
